/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageItem/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ImageItem({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Gallery/Content/PatientImages/AllImages/PatientImage/Content/ImageItem",
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected,
  isHovered
  
})
let resourceObjectMetaUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'url',
})
  return (<React.Fragment
>
<button
  data-testid="ImageItem.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--o-1-1khv3a': isSelected ? 1 : 0.5,'--bc-2-1khv3a': isSelected ? "rgba(0,188,112, 0.1)" : isHovered ? "rgba(111,111,111, 0.1)" : "#ffff"}}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="resource_object_meta.url"
 url={resourceObjectMetaUrlValueData}
/>
</button>
{children}
</React.Fragment>)
}